import script from "./AppMobile.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppMobile.vue?vue&type=script&setup=true&lang=ts"

import "./AppMobile.vue?vue&type=style&index=0&id=2758eff7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2758eff7"]])

export default __exports__